export default __webpack_public_path__ + "static/media/HOSTLOC_Dashboard.75248059.svg";